import React from 'react';
import DocumentReader from './DocumentReader';
import { documentTitle, documentSlug, parts } from './content/informationIdeasReference';

export default function InformationIdeasReference() {
  return (
    <DocumentReader
      documentId={documentSlug}
      title={documentTitle}
      intro="Quick-lookup checklists for Information and Ideas — central idea vs. detail, textual and quantitative evidence, and the inference test."
      parts={parts}
    />
  );
}
